@if (mode === 'list') {
  <div id="fillings-filters">
    <form [formGroup]="fillingFilters">
      @if ((filtersLevels.securityLevel?.length > 1 && !isSliderDisabled) || config().IccConfig.Configurators.fillingsSelect.showGlazingsForSliderValues) {
        <h3>{{ 'WINDOW|Bezpieczeństwo' | translate}}</h3>
      }
      @if ((filtersLevels.securityLevel?.length > 1 && !isSliderDisabled) && !(config().IccConfig.Configurators.fillingsSelect.showGlazingsForSliderValues && filtersLevels.securityLevel?.length > 1)) {
        <icc-slider  [steps]="filtersLevels.securityLevel" formControlName="securityLevel"></icc-slider>
      }
      @if ((config().IccConfig.Configurators.fillingsSelect.showGlazingsForSliderValues && filtersLevels.securityLevel?.length > 1)) {
        <icc-slider  [steps]="filtersLevels.securityLevel" formControlName="securityLevel" (change)="getGlazingsForSecurityPackage($event.id)"
        ></icc-slider>
      }
      @if ((filtersLevels.securityLevel?.length > 1 && !isSliderDisabled) || config().IccConfig.Configurators.fillingsSelect.showGlazingsForSliderValues) {
        <p>{{ securityLevelDescription }}</p>
      }
      @if (filtersLevels.glassType?.length > 1 || filtersLevels.glassType?.length === 1 && filtersLevels.glassTypeVariant.length > 1 || config().IccConfig.Configurators.fillingsSelect.showGlazingsForSliderValues) {
        <h3>{{ 'WINDOW|Kolor szyby' | translate}}</h3>
      }
      @if (filtersLevels.glassType?.length > 1) {
        <div class="glass-type-select">
          @for (type of filtersLevels.glassType; track type) {
            <div (click)="changeGlassType(type)" [class.selected]="fillingFilters.get('glassType')?.value == type?.id">
              <div class="item-imgTitle">
                <img class="item-imgTitle-img" [src]="('/files/glasstype/' + type.image)" [alt]="type.name" defaultImg>
                <p class="item-imgTitle-title">{{ type.name }}</p>
              </div>
            </div>
          }
        </div>
      }
      @if (filtersLevels.glassType?.length === 1 && filtersLevels.glassTypeVariant.length > 1 && !config().IccConfig.Configurators.fillingsSelect.showGlazingsForSliderValues) {
        <div class="glass-type-select">
          @for (type of filtersLevels.glassTypeVariant; track type) {
            <div (click)="changeGlassTypeVariant(type)" [class.selected]="fillingFilters.get('glassTypeVariant')?.value == type?.id">
              <div class="item-imgTitle">
                <img class="item-imgTitle-img" [src]="('/files/glasstypevariant/' + type.image)" [alt]="type.name" defaultImg>
                <p class="item-imgTitle-title">{{ type.name }}</p>
              </div>
            </div>
          }
        </div>
      }
      @if (config().IccConfig.Configurators.fillingsSelect.showGlazingsForSliderValues) {
        <div class="glass-type-select">
          @for (type of filtersLevels.glassTypeVariant; track type) {
            @for (glazing of availableGlazingColors; track glazing) {
              @if (type.id === glazing.filters.glassTypeVariant) {
                <div (click)="changeGlassTypeVariant(type)" [class.selected]="fillingFilters.get('glassTypeVariant')?.value == type?.id">
                  <div class="item-imgTitle">
                    <img class="item-imgTitle-img" [src]="('/files/glasstypevariant/' + type.image)" [alt]="type.name" defaultImg>
                    <p class="item-imgTitle-title">{{ type.name }}</p>
                  </div>
                </div>
              }
            }
          }
        </div>
      }
      @if (getMatchingVariants().length > 0) {
        <icc-select-box [title]="'WINDOW|Wariant szyby' | translate"
          [description]="selectedGlassTypeVariant?.name"
          [imageUrl]="'/files/glasstypevariant/' + (selectedGlassTypeVariant?.image || '')"
          [buttonText]="'INTERFACE|Zmień' | translate"
          [disabledButton1]="getMatchingVariants().length <= 1"
          (select)="selectGlassTypeVariant()"
        ></icc-select-box>
      }
    </form>
  </div>
}
@if (selectedFilling && mode === 'list') {
  <div class="selected-summary mat-elevation-z4">
    <img [src]="'/files/filling/' + (selectedFilling?.image || '')" defaultImg>
    <p>{{ selectedFilling?.name }}</p>
  </div>
}
@if (mode === 'extra') {
  @if (leftLightFillingBox.show) {
    <icc-select-box [title]="leftLightFillingBox?.title"
      [description]="leftLightFillingBox?.name"
      [imageUrl]="leftLightFillingBox?.img"
      [buttonText]="'INTERFACE|Zmień' | translate"
      [disabledButton1]="isFillingSelectionDisabled('doorLeftLight')"
      [descriptionTemplate]="fillingBoxTemplate"
      [descriptionContext]="{box: leftLightFillingBox}"
      (select)="openModalFilling('doorLeftLight')"
    ></icc-select-box>
  }
  @if (rightLightFillingBox.show) {
    <icc-select-box [title]="rightLightFillingBox?.title"
      [description]="rightLightFillingBox?.name"
      [imageUrl]="rightLightFillingBox?.img"
      [buttonText]="'INTERFACE|Zmień' | translate"
      [disabledButton1]="isFillingSelectionDisabled('doorRightLight')"
      [descriptionTemplate]="fillingBoxTemplate"
      [descriptionContext]="{box: rightLightFillingBox}"
      (select)="openModalFilling('doorRightLight')"
    ></icc-select-box>
  }
  @if (topLightFillingBox.show) {
    <icc-select-box [title]="topLightFillingBox?.title"
      [description]="topLightFillingBox?.name"
      [imageUrl]="topLightFillingBox?.img"
      [buttonText]="'INTERFACE|Zmień' | translate"
      [disabledButton1]="isFillingSelectionDisabled('doorTopLight')"
      [descriptionTemplate]="fillingBoxTemplate"
      [descriptionContext]="{box: topLightFillingBox}"
      (select)="openModalFilling('doorTopLight')"
    ></icc-select-box>
  }
}
<ng-template #fillingBoxTemplate let-box="box">
  @if (box.oneGlazing && box.type != 'deco_panels') {
    <p class="glassTypeDescription"
      >
      {{box.name}}<br>
      U<sub>g</sub> = {{box.u}}
      @if (box.bondedGlazing) {
        <span>
          <br>
            {{ 'WINDOW|Wklejane szyby' | translate }}
          </span>
        }
        @if (box.bondedGlazing && box.partlyBondedGlazing) {
          <span>
            <br>
              {{ 'WINDOW|Wklejane szyby w części kwater.' | translate }}
            </span>
          }
        </p>
      }
      @if (!box.oneGlazing) {
        <p class="glassTypeDescription">
          {{ 'WINDOW|Różne pakiety w poszczególnych kwaterach, szczegóły w podsumowaniu.' | translate }}
        </p>
      }
    </ng-template>
